import { StyledScreenReaderSpan } from '@tvg/fuse-utils';
import PropTypes from 'prop-types';
import React from 'react';
import defaultConfig from './config';
import { StyledLoadingSpinner, StyledLoadingSpinnerWrapper } from './styled-loading-spinner';

const { forwardRef } = React;
const { colours } = defaultConfig;

const propTypes = {
	animationTime: PropTypes.number,
	className: PropTypes.string,
	dataTestId: PropTypes.string,
	size: PropTypes.oneOf(['responsive', 'xsmall', 'small', 'medium', 'large']),
	variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
};

const defaultProps = {
	animationTime: 0.5,
	className: undefined,
	dataTestId: 'fuse-loading-spinner-data-test-id',
	size: 'responsive',
	variant: 'primary',
};

const LoadingSpinner = forwardRef(
	({ dataTestId, size, variant, animationTime, className, ...rest }, ref) => (
		<StyledLoadingSpinnerWrapper className={className} data-testid={dataTestId} ref={ref} {...rest}>
			<StyledLoadingSpinner
				colour={colours[`${variant}`]}
				aria-live="polite"
				role="status"
				size={size}
				animationTime={animationTime}
			>
				<svg viewBox="0 0 50 50" aria-hidden="true">
					<circle cx="25" cy="25" r="20" fill="none" strokeWidth="5" />
				</svg>
				<StyledScreenReaderSpan className="fuse-loading-spinner__screen-reader-only">
					Loading
				</StyledScreenReaderSpan>
			</StyledLoadingSpinner>
		</StyledLoadingSpinnerWrapper>
	),
);

LoadingSpinner.propTypes = propTypes;
LoadingSpinner.defaultProps = defaultProps;

export default LoadingSpinner;

export { LoadingSpinner };
